import { render } from "./courtyards-section.vue?vue&type=template&id=4c946046"
import script from "./courtyards-section.vue?vue&type=script&lang=js"
export * from "./courtyards-section.vue?vue&type=script&lang=js"

import "./courtyards-section.vue?vue&type=style&index=0&id=4c946046&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__